/*
  HALO Stories (sections/halo-stories.liquid).

  - Prévia: o vídeo de cada bolinha só carrega e toca, sem som, quando a bolinha aparece na tela,
    na versão 480p e só nos primeiros segundos (em loop), para baixar pouco. Sem prévia com
    "reduzir movimento", economia de dados ou no editor.
  - A Shopify só entrega ao Liquid o mp4 original; as versões 480p e 720p têm o mesmo endereço com
    outro trecho no nome. Se uma delas não existir, volta para o original.
  - Movimento (computador): se as bolinhas não cabem, a lista ganha uma cópia ao lado e anda sem
    parar (para ao passar o mouse ou com o foco do teclado). No celular, deslizam pelo dedo.
  - Player: fica no canto da tela (vai para o fim da página, para não depender de nenhuma
    seção) e não cobre o resto. Vídeo com som (se ligado e se o navegador deixar), barras de
    progresso, toque à esquerda volta e à direita avança, pausa, som e fechar. Ao terminar um
    vídeo, passa para o próximo; depois do último, fecha. Esc fecha; setas trocam de story.
  - Cartão do perfil em 3D: gira no próprio eixo diagonal conforme a rolagem (para um lado ao
    descer a página, para o outro ao subir) e volta reto quando a rolagem para, com um reflexo
    que acompanha o giro. Não sai do lugar. Parado com "reduzir movimento" ou com 0 no
    personalizador.
  - O player fica acima da barra fixa de compra (.sticky-atc) quando ela aparece e pode ser
    arrastado (dedo ou mouse) para qualquer lugar da tela, sem descer sobre a barra. Um toque
    curto continua trocando de story; só um arraste de verdade move o player.
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-stories')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 768px)');

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function saveData() {
    return !!(navigator.connection && navigator.connection.saveData);
  }

  var PREVIEW_SECONDS = 4;
  var GAP = 12;
  var DRAG_THRESHOLD = 6;

  // Topo da barra fixa de compra, se ela estiver à mostra; senão, o fim da tela.
  function bottomLimit() {
    var bar = document.querySelector('.sticky-atc.is-visible');
    if (bar) {
      var rect = bar.getBoundingClientRect();
      if (rect.height && rect.top < window.innerHeight) return rect.top;
    }
    return window.innerHeight;
  }
  var RENDITION = /\.(?:HD|SD)-\d+p-[\d.]+Mbps-/;

  // ".HD-1080p-2.5Mbps-123.mp4" vira ".SD-480p-0.9Mbps-123.mp4" (ou outra versão).
  function rendition(url, tag) {
    return RENDITION.test(url) ? url.replace(RENDITION, '.' + tag + '-') : url;
  }

  // Põe uma versão menor do vídeo e, se ela falhar, o original.
  function setSource(video, original, tag) {
    var lighter = rendition(original, tag);
    video.onerror = null;
    if (lighter !== original) {
      video.onerror = function () {
        video.onerror = null;
        video.src = original;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      };
    }
    video.src = lighter;
  }

  class HaloStories extends HTMLElement {
    connectedCallback() {
      if (this.haloPronto) return;
      this.haloPronto = true;

      var data = this.querySelector('[data-hst-dados]');
      try {
        this.stories = JSON.parse(data.textContent);
      } catch (e) {
        this.stories = [];
      }
      this.faixa = this.querySelector('[data-hst-faixa]');
      this.trilho = this.querySelector('[data-hst-trilho]');
      this.lista = this.querySelector('[data-hst-lista]');
      this.muted = this.dataset.som !== 'true';
      this.index = -1;

      this.player = this.querySelector('[data-hst-player]');
      if (this.player) document.body.appendChild(this.player);
      this.video = this.player.querySelector('[data-hst-video]');
      this.barras = this.player.querySelector('[data-hst-barras]');

      this.onKey = this.onKey.bind(this);
      this.tick = this.tick.bind(this);
      this.setupMarquee = this.setupMarquee.bind(this);
      this.place = this.place.bind(this);
      this.onPlace = this.onPlace.bind(this);
      this.onDragMove = this.onDragMove.bind(this);
      this.onDragEnd = this.onDragEnd.bind(this);
      this.player.addEventListener('pointerdown', this.onDragStart.bind(this));
      // Depois de um arraste, o clique que o navegador dispara no fim não conta como toque.
      this.player.addEventListener(
        'click',
        function (e) {
          if (!this.dragged) return;
          this.dragged = false;
          e.preventDefault();
          e.stopPropagation();
        }.bind(this),
        true
      );

      this.addEventListener('click', this.onOpenClick.bind(this));
      this.player.addEventListener('click', this.onPlayerClick.bind(this));
      this.video.addEventListener('ended', this.next.bind(this));
      this.video.addEventListener('playing', this.tick);

      this.setupMarquee();
      desktop.addEventListener('change', this.setupMarquee);
      this.setupPreviews();
      this.setupCardMotion();
    }

    // Cartão 3D: a velocidade da rolagem vira inclinação (rotate3d no eixo diagonal), que
    // perde força sozinha e volta a zero quando a rolagem para. Só perto da tela.
    setupCardMotion() {
      var card = this.querySelector('[data-hst-perfil]');
      var maxDeg = parseFloat(this.dataset.inclinacao) || 0;
      if (!card || !maxDeg || reduceMotion.matches || !('IntersectionObserver' in window)) return;
      var self = this;
      var lastY = window.scrollY;
      var push = 0;
      var shown = 0;
      var frame = 0;

      function render(t) {
        card.style.transform = 'perspective(900px) rotate3d(1, 1, 0, ' + (t * maxDeg).toFixed(2) + 'deg)';
        card.style.setProperty('--hst-brilho-x', (t * 40).toFixed(1) + '%');
        card.style.setProperty('--hst-brilho-o', Math.min(1, Math.abs(t) * 1.5).toFixed(2));
      }

      function tick() {
        frame = 0;
        push *= 0.86;
        shown += (push - shown) * 0.16;
        if (Math.abs(push) < 0.001 && Math.abs(shown) < 0.001) {
          push = 0;
          shown = 0;
          render(0);
          return;
        }
        render(shown);
        frame = requestAnimationFrame(tick);
      }

      this.onCardScroll = function () {
        var y = window.scrollY;
        // Descer gira para um lado, subir para o outro; rolagem rápida inclina mais.
        push = Math.max(-1, Math.min(1, push + (y - lastY) / 120));
        lastY = y;
        if (!frame) frame = requestAnimationFrame(tick);
      };
      this.cardObserver = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            lastY = window.scrollY;
            window.addEventListener('scroll', self.onCardScroll, { passive: true });
          } else {
            window.removeEventListener('scroll', self.onCardScroll);
          }
        },
        { rootMargin: '25% 0px' }
      );
      this.cardObserver.observe(this);
    }

    disconnectedCallback() {
      this.close();
      if (this.player && this.player.parentNode) this.player.parentNode.removeChild(this.player);
      if (this.observer) this.observer.disconnect();
      if (this.cardObserver) this.cardObserver.disconnect();
      if (this.onCardScroll) window.removeEventListener('scroll', this.onCardScroll);
      desktop.removeEventListener('change', this.setupMarquee);
      this.haloPronto = false;
    }

    // Movimento no computador quando as bolinhas não cabem na largura.
    setupMarquee() {
      var moving = this.faixa.classList.contains('is-movendo');
      if (moving) {
        var mover = this.trilho.querySelector('.halo-stories__trilho-movel');
        var clone = mover.querySelector('[data-hst-clone]');
        if (clone) mover.removeChild(clone);
        this.trilho.appendChild(this.lista);
        this.trilho.removeChild(mover);
        this.faixa.classList.remove('is-movendo');
      }
      var allowed = this.dataset.movimento === 'true' && desktop.matches && !reduceMotion.matches && !designMode();
      if (!allowed || this.lista.scrollWidth <= this.trilho.clientWidth) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'halo-stories__trilho-movel';
      var copy = this.lista.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-hst-clone', '');
      copy.removeAttribute('data-hst-lista');
      copy.querySelectorAll('button').forEach(function (button) {
        button.tabIndex = -1;
      });
      copy.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
        el.removeAttribute('data-shopify-editor-block');
      });
      wrapper.appendChild(this.lista);
      wrapper.appendChild(copy);
      this.trilho.appendChild(wrapper);
      this.faixa.classList.add('is-movendo');
      if (this.observer) {
        var observer = this.observer;
        copy.querySelectorAll('.halo-stories__previa').forEach(function (video) {
          video.classList.remove('is-tocando');
          observer.observe(video);
        });
      }
    }

    // Prévia sem som só nas bolinhas visíveis.
    setupPreviews() {
      if (this.dataset.previa !== 'true' || reduceMotion.matches || saveData() || designMode()) return;
      if (!('IntersectionObserver' in window)) return;
      var self = this;
      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && self.index < 0) self.playPreview(video);
            else video.pause();
          });
        },
        { rootMargin: '100px' }
      );
      this.querySelectorAll('.halo-stories__previa').forEach(function (video) {
        self.observer.observe(video);
      });
    }

    playPreview(video) {
      if (!video.src && video.dataset.src) {
        setSource(video, video.dataset.src, 'SD-480p-0.9Mbps');
        video.addEventListener(
          'playing',
          function () {
            video.classList.add('is-tocando');
          },
          { once: true }
        );
        // Só os primeiros segundos, em loop.
        video.addEventListener('timeupdate', function () {
          if (video.currentTime >= PREVIEW_SECONDS) video.currentTime = 0;
        });
      }
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    setPreviews(playing) {
      var self = this;
      this.querySelectorAll('.halo-stories__previa').forEach(function (video) {
        if (!playing) {
          video.pause();
          return;
        }
        var rect = video.getBoundingClientRect();
        var visible = rect.bottom > 0 && rect.top < window.innerHeight && video.src;
        if (visible) self.playPreview(video);
      });
    }

    onOpenClick(e) {
      var button = e.target.closest && e.target.closest('[data-hst-abrir]');
      if (!button) return;
      this.opener = button;
      this.open(Number(button.dataset.hstAbrir) || 0);
    }

    onPlayerClick(e) {
      var target = e.target.closest ? e.target : null;
      if (!target) return;
      if (target.closest('[data-hst-fechar]')) this.close();
      else if (target.closest('[data-hst-anterior]')) this.prev();
      else if (target.closest('[data-hst-proxima]')) this.next();
      else if (target.closest('[data-hst-pausa]')) this.togglePause();
      else if (target.closest('[data-hst-som]')) this.toggleSound();
    }

    onKey(e) {
      if (e.key === 'Escape') this.close();
      else if (e.key === 'ArrowRight') this.next();
      else if (e.key === 'ArrowLeft') this.prev();
    }

    open(index) {
      if (!this.stories.length) return;
      var wasOpen = this.index >= 0;
      this.buildBars();
      this.player.hidden = false;
      this.faixa.classList.add('is-parada');
      this.setPreviews(false);
      this.show(index);
      this.place();
      if (!wasOpen) {
        document.addEventListener('keydown', this.onKey);
        window.addEventListener('scroll', this.onPlace, { passive: true });
        window.addEventListener('resize', this.onPlace);
        var close = this.player.querySelector('[data-hst-fechar]');
        if (close) close.focus({ preventScroll: true });
      }
    }

    close() {
      if (this.index < 0) return;
      this.index = -1;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.video.pause();
      this.video.onerror = null;
      this.video.removeAttribute('src');
      this.video.load();
      this.player.hidden = true;
      this.faixa.classList.remove('is-parada');
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('scroll', this.onPlace);
      window.removeEventListener('resize', this.onPlace);
      this.setPreviews(true);
      if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
    }

    // Posição do player: no canto, acima da barra de compra; ou onde o cliente arrastou,
    // sempre dentro da tela e acima da barra.
    onPlace() {
      cancelAnimationFrame(this.placeFrame);
      this.placeFrame = requestAnimationFrame(this.place);
    }

    place() {
      if (this.player.hidden) return;
      var limit = bottomLimit();
      this.player.classList.toggle('is-movido', !!this.pos);
      if (!this.pos) {
        this.player.style.left = '';
        this.player.style.top = '';
        this.player.style.removeProperty('--hst-lift');
        var lift = window.innerHeight - limit;
        if (lift > 0) this.player.style.setProperty('--hst-lift', lift + 'px');
        return;
      }
      var rect = this.player.getBoundingClientRect();
      var left = Math.min(Math.max(GAP, this.pos.left), window.innerWidth - rect.width - GAP);
      var top = Math.min(Math.max(GAP, this.pos.top), limit - rect.height - GAP);
      this.pos = { left: left, top: Math.max(GAP, top) };
      this.player.style.left = this.pos.left + 'px';
      this.player.style.top = this.pos.top + 'px';
    }

    onDragStart(e) {
      if (e.button !== 0 || this.player.hidden) return;
      var rect = this.player.getBoundingClientRect();
      this.drag = { x: e.clientX, y: e.clientY, left: rect.left, top: rect.top, moved: false };
      window.addEventListener('pointermove', this.onDragMove);
      window.addEventListener('pointerup', this.onDragEnd);
      window.addEventListener('pointercancel', this.onDragEnd);
    }

    onDragMove(e) {
      var drag = this.drag;
      if (!drag) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        drag.moved = true;
        this.player.classList.add('is-arrastando');
      }
      e.preventDefault();
      this.pos = { left: drag.left + dx, top: drag.top + dy };
      this.place();
    }

    onDragEnd() {
      window.removeEventListener('pointermove', this.onDragMove);
      window.removeEventListener('pointerup', this.onDragEnd);
      window.removeEventListener('pointercancel', this.onDragEnd);
      if (this.drag && this.drag.moved) {
        this.dragged = true;
        this.player.classList.remove('is-arrastando');
      }
      this.drag = null;
    }

    buildBars() {
      if (this.barras.children.length === this.stories.length) return;
      this.barras.textContent = '';
      for (var i = 0; i < this.stories.length; i++) {
        var bar = document.createElement('span');
        bar.className = 'halo-stories__barra';
        bar.appendChild(document.createElement('span'));
        this.barras.appendChild(bar);
      }
    }

    setBar(index, value) {
      var fill = this.barras.children[index] && this.barras.children[index].firstChild;
      if (fill) fill.style.setProperty('--p', String(Math.max(0, Math.min(1, value))));
    }

    show(index) {
      var story = this.stories[index];
      if (!story) return;
      this.index = index;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      for (var i = 0; i < this.stories.length; i++) this.setBar(i, i < index ? 1 : 0);
      this.setPaused(false);

      var text = this.player.querySelector('[data-hst-texto]');
      text.textContent = story.texto || '';
      var cta = this.player.querySelector('[data-hst-cta]');
      if (story.link) {
        cta.href = story.link;
        cta.querySelector('[data-hst-cta-texto]').textContent = story.linkTexto || '';
        cta.hidden = false;
      } else {
        cta.hidden = true;
      }

      this.video.poster = story.capa || '';
      if (!story.video) {
        // Story sem vídeo: mostra a capa por alguns segundos.
        this.video.removeAttribute('src');
        this.video.load();
        this.stillStart = performance.now();
        this.tickStill();
        return;
      }
      setSource(this.video, story.video, 'HD-720p-1.6Mbps');
      this.video.muted = this.muted;
      this.updateSoundButton();
      this.play();
    }

    play() {
      var self = this;
      var attempt = this.video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Sem permissão para tocar com som: toca sem som e mostra o botão de som desligado.
          if (!self.video.muted) {
            self.muted = true;
            self.video.muted = true;
            self.updateSoundButton();
            self.video.play().catch(function () {});
          }
        });
      }
    }

    tick() {
      if (this.index < 0) return;
      var duration = this.video.duration;
      if (duration) this.setBar(this.index, this.video.currentTime / duration);
      this.frame = requestAnimationFrame(this.tick);
    }

    tickStill() {
      var self = this;
      if (this.index < 0) return;
      var progress = (performance.now() - this.stillStart) / 5000;
      this.setBar(this.index, progress);
      if (progress >= 1) {
        this.next();
        return;
      }
      this.frame = requestAnimationFrame(function () {
        self.tickStill();
      });
    }

    next() {
      if (this.index < 0) return;
      if (this.index >= this.stories.length - 1) this.close();
      else this.show(this.index + 1);
    }

    prev() {
      if (this.index < 0) return;
      if (this.video.currentTime > 2 || this.index === 0) {
        this.video.currentTime = 0;
        this.play();
      } else {
        this.show(this.index - 1);
      }
    }

    setPaused(paused) {
      var button = this.player.querySelector('[data-hst-pausa]');
      button.dataset.state = paused ? 'paused' : 'playing';
      button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
    }

    togglePause() {
      if (this.video.paused) {
        this.play();
        this.setPaused(false);
      } else {
        this.video.pause();
        this.setPaused(true);
      }
    }

    updateSoundButton() {
      var button = this.player.querySelector('[data-hst-som]');
      if (this.muted) button.setAttribute('data-mudo', '');
      else button.removeAttribute('data-mudo');
      button.setAttribute('aria-label', this.muted ? button.dataset.labelOn : button.dataset.labelOff);
    }

    toggleSound() {
      this.muted = !this.muted;
      this.video.muted = this.muted;
      this.updateSoundButton();
    }
  }

  customElements.define('halo-stories', HaloStories);
})();
